module.exports = __webpack_public_path__ + "static/media/product-manufacturing-thumbnail.44892acc.png";